import styled from 'styled-components'

export const StyledTable = styled.table`
    border-collapse: collapse;
    width: 100%;
    border-radius: 4px;
    font-family: "Roboto", Arial, Helvetica, sans-serif;
    font-size: 16px;
    @media (max-width: 425px) {
      font-size: 14px;
    }  
`

export const StyledTableCell = styled.td`
    border: 1px solid #BEBEC1;
    padding: 16px;
    font-weight: 400;
    line-height: 165%;
    letter-spacing: 0em;
    text-align: left;
    color: #282832;
`

export const StyledMethodContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const StyledDeliveryDate = styled.td`
    border: 1px solid #BEBEC1;
    padding: 16px;
    font-weight: 500;
    line-height: 165%;
    letter-spacing: 0em;
    text-align: left;
    color: #282832;
`

export const StyledTableHeader = styled.th`
    border: 1px solid #BEBEC1;
    padding: 16px;
    text-align: left;
    background-color: #282832;
    color: white;
    font-size: 16px;
    font-weight: 400;
    line-height: 165%;
    letter-spacing: 0em;
    text-align: left;

    & > small {
      font-size: 14px;
    }
`
